import { useQuery } from "@tanstack/react-query";
import { getIntegrations } from "../services/integrations";

export function useIntegrations(options = {}) {

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    return useQuery({

        queryKey: [

            "integrations",

            outletUid,

        ],

        queryFn: () =>

            getIntegrations(

                outletUid

            ),

        enabled: !!outletUid,

        staleTime: 1000 * 60 * 5,

        ...options,

    });

}